import emitterDataConfigApi from '@/api/config/emitterDataConfig'
import { queryKeys } from '@/constant/common'
import { UpdateEmitter } from '@/types/emitter'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function updateEmitter(payload: UpdateEmitter): Promise<void> {
  await emitterDataConfigApi.update(payload)
}

function useUpdateEmitter() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: UpdateEmitter) => updateEmitter(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.emitter])
      toast.success(t('updateEmitterSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else toast.error(t('updateEmitterError'))
    },
  })
}

export default useUpdateEmitter
